import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "d-flex flex-column gr-4 pa-4 rounded elevation-1",
      attrs: { "data-qa": "appointment_data_doctor" },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex align-center gc-4" },
        [
          _c(VImg, {
            staticClass: "rounded-sm border-sm flex-grow-0",
            attrs: {
              width: "80",
              height: "80",
              src: _vm.doctor.imageSrc,
              alt: _vm.doctor.fullName,
            },
          }),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                staticClass: "text-subtitle-1 text--text",
                attrs: { "data-qa": "appointment_data_doctor_name" },
              },
              [_vm._v("\n        " + _vm._s(_vm.doctor.fullName) + "\n      ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "text-body-2 text-secondary--text",
                attrs: { "data-qa": "appointment_data_doctor_description" },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_setup.getDoctorDescription(_vm.doctor)) +
                    "\n      "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pa-4" }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.isAnyTelemed ? _c(_setup.SelectSpeciality) : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }